import React from "react";
import "./collection-banner.scss";

/**
 * Displays a decorative banner for a collection.
 */
const CollectionBanner = ({
  handle,
  title,
}: {
  handle?: string;
  title: string;
}) => {
  return (
    <div
      className={`collection-list__banner ${handle}`}
    >
      <span>{title}</span>
    </div>
  );
};

export { CollectionBanner };
